export default class {

    constructor(tradePointId) {

        this.Id = null;

        this.Status = 1;

        this.Text = null;

        this.DataCreated = new Date();

        this.DateFinished = new Date(2000, 0, 1);

        this.PlannedFinishDate = null;

        this.ChangeDate = new Date();

        this.TradePointId = tradePointId;

        this.Category = null;    

        this.Creator = null;    

        this.Finisher = null;
    }
    
    IsValid() {
        return Boolean(this.Text) &&
               Boolean(this.Category) &&
               Boolean(this.PlannedFinishDate);

    }

    mapToDto() {
        let result = JSON.parse(JSON.stringify(this));
        
        result.PlannedFinishDate = new Date(result.PlannedFinishDate);
        result.Category = { Id: result.Category.Id, FullName: result.Category.Name };

        return result;
    }


}